<!--
 * @Author: your name
 * @Date: 2020-09-22 15:14:06
 * @LastEditTime: 2020-12-30 15:11:45
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/pay/component/DownLoadTax/index.vue
-->
<style scoped lang="sass">
.download_tax
  padding-left: 17px
  padding-right: 17px
  margin-bottom: 40px

  .title
    font-size: 12px
    line-height: 16px
    margin-bottom: 10px
    color: var(--menu-primary-text-colour) !important

  .down
    font-size: 12px
    text-decoration-line: underline
    color: var(--menu-primary-background-colour) !important
</style>

<template lang="pug">
.download_tax(v-if="!isCounterPay")
  .title.o(v-if="!isPostPaid") Your receipt has been sent to {{ email }}.
  .down.b
    span.p(@click="downLoadTax") Download tax invoice

</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { getInvoice } from 'api/product'
import { saveAs } from 'file-saver'

@Component({
  props: {
    orderId: {
      type: [String, Number]
    },
    isPostPaid: {
      type: Boolean
    },
    email: {
      type: String
    },
    name: {
      type: String
    },
    isCounterPay: {
      type: Boolean
    }
  }

})
class DownLoadTax extends Vue {
  downLoadTax() {
    getInvoice({
      id: this.orderId,
      output: 'pdf',
      user_id: localStorage.getItem('userId') || ''
    }).then(res => {
      saveAs(res, `${this.name}.pdf`)
    })
  }
}

export default DownLoadTax
</script>
